import React from 'react';
import { css } from '@emotion/css';
import { GRAY300, TEAL200 } from '../../../../../../domain/colors';
import type { ContractSource } from '../../../../../../@types/membership';
import { Msg } from '@/i18n';

const styles = {
  deletionPeriod: {
    tableHead: {
      borderBottom: `2px solid ${TEAL200}`,
    },
    tableBody: {
      borderBottom: `1px solid ${GRAY300}`,
    },
  },
  overviewTab: {
    maxWidth: 530,
    withTwoButtons: {
      '@media (max-width: 420px)': {
        marginBottom: 52,
      },
    },
  },
  buttonAreaBasicButtonOne: {
    width: 185,
    margin: '0 8px',
    '@media (max-width: 420px)': {
      width: 285,
      display: 'block',
      margin: '0 auto 8px',
    },
  },
  buttonAreaBasicButtonTwo: {
    width: 185,
    margin: '0 8px',
    '@media (max-width: 420px)': {
      width: 285,
      display: 'block',
      margin: '8px auto 0',
    },
  },
  tenantOther: css`
    border: 1px solid rgb(214, 214, 214);
    border-radius: 4px;
    padding: 16px;
  `,
};

interface OverviewTabProps {
  key: string;
  isBuyerPlus?: ContractSource;
}

const OverviewTab = ({ isBuyerPlus }: OverviewTabProps) => {
  return (
    <div className={`${css(styles.overviewTab, !isBuyerPlus && styles.overviewTab.withTwoButtons)}`}>
      <div className='font-heading-xsmall-regular padding-bottom-m'>
        <Msg
          id='benefits.tenantProtectionServices.modal.overview.paragraph'
          defaultMessage='Mit MieterEngel bist du bei Mietproblemen abgesichert. Digital und modern.'
        />
      </div>
      <div className='padding-bottom-m'>
        <Msg
          id='benefits.tenantProtectionServices.modal.overview.var1'
          defaultMessage='In MieterPlus und WohnenPlus enthalten - ab dem ersten Tag.'
        />
      </div>
      <div className='font-heading-xsmall-regular padding-bottom-s'>
        <Msg
          id='benefits.tenantProtectionServices.modal.overview.checkmark.title'
          defaultMessage='Mit MieterEngel bist du bei Mietproblemen abgesichert. Digital und modern.'
        />
      </div>
      <ul className='list-check list-spacing-s padding-bottom-m'>
        <li>
          <span className='font-body-medium-bold'>
            <Msg
              id='benefits.tenantProtectionServices.modal.overview.checkmark.list.item1.title'
              defaultMessage='Lass deinen Mietvertrag prüfen:'
            />
          </span>
          <br />
          <Msg
            id='benefits.tenantProtectionServices.modal.overview.checkmark.list.item1.text'
            defaultMessage='Lass deinen Mietvertrag prüfen:'
          />
        </li>
        <li>
          <span className='font-body-medium-bold'>
            <Msg
              id='benefits.tenantProtectionServices.modal.overview.checkmark.list.item2.title'
              defaultMessage='Lass deinen Mietvertrag prüfen:'
            />
          </span>
          <br />
          <Msg
            id='benefits.tenantProtectionServices.modal.overview.checkmark.list.item2.text'
            defaultMessage='Lass deinen Mietvertrag prüfen:'
          />
        </li>
        <li>
          <span className='font-body-medium-bold'>
            <Msg
              id='benefits.tenantProtectionServices.modal.overview.checkmark.list.item3.title'
              defaultMessage='Lass deinen Mietvertrag prüfen:'
            />
          </span>
          <br />
          <Msg
            id='benefits.tenantProtectionServices.modal.overview.checkmark.list.item3.text'
            defaultMessage='Lass deinen Mietvertrag prüfen:'
          />
        </li>
        <li>
          <span className='font-body-medium-bold'>
            <Msg
              id='benefits.tenantProtectionServices.modal.overview.checkmark.list.item4.title'
              defaultMessage='Lass deinen Mietvertrag prüfen:'
            />
          </span>
          <br />
          <Msg
            id='benefits.tenantProtectionServices.modal.overview.checkmark.list.item4.text'
            defaultMessage='Lass deinen Mietvertrag prüfen:'
          />
        </li>
      </ul>
      <div className='font-heading-xsmall-regular padding-bottom-s'>
        <Msg
          id='benefits.tenantProtectionServices.modal.overview.bulletList.title'
          defaultMessage='Deine Rechtsberatung von Partneranwälten:innen'
        />
      </div>
      <ul className='list-bullet list-spacing-s padding-bottom-m'>
        <li>
          <Msg
            id='benefits.tenantProtectionServices.modal.overview.bulletList.item1'
            defaultMessage='Zu allen Mietproblemen'
          />
        </li>
        <li>
          <Msg
            id='benefits.tenantProtectionServices.modal.overview.bulletList.item2'
            defaultMessage='Telefonisch & schriftlich'
          />
        </li>
        <li>
          <Msg
            id='benefits.tenantProtectionServices.modal.overview.bulletList.item3'
            defaultMessage='Antwort in der Regel in 48h'
          />
        </li>
        <li>
          <Msg
            id='benefits.tenantProtectionServices.modal.overview.bulletList.item4'
            defaultMessage='1x jährliche Nebenkostenprüfung'
          />
        </li>
        <li>
          <Msg
            id='benefits.tenantProtectionServices.modal.overview.bulletList.item5'
            defaultMessage='Feste Ansprechperson über das ganze Jahr'
          />
        </li>
      </ul>
      <div className={styles.tenantOther}>
        <div className='font-heading-xsmall-bold padding-bottom-m'>
          <Msg
            id='benefits.tenantProtectionServices.modal.overview.footerSection.title'
            defaultMessage='Weitere MieterEngel Vorteile:'
          />
        </div>
        <div className='font-body-small-regular padding-bottom-s'>
          <Msg
            id='benefits.tenantProtectionServices.modal.overview.footerSection.list.item1'
            defaultMessage='Online Kundenkonto & Betreuung durch MieterEngel Team'
          />
        </div>
        <div className='font-body-small-regular padding-bottom-s'>
          <Msg
            id='benefits.tenantProtectionServices.modal.overview.footerSection.list.item2'
            defaultMessage='Mietrecht einfach & verständlich: 200+ Ratgeber, Checklisten und Muster'
          />
        </div>
        <div className='font-body-small-regular padding-bottom-s'>
          <Msg
            id='benefits.tenantProtectionServices.modal.overview.footerSection.list.item3'
            defaultMessage='Vorlagen & Editor für deine Kommunikation mit Vermieter:innen oder der Hausverwaltung'
          />
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
